import Component from "./PaymentsHeader";

export default Component;
